// /legal/terms — static terms of service page
import React from 'react';

interface Props {
  onBack: () => void;
}

export function TermsPage({ onBack }: Props) {
  return (
    <div style={pageStyle}>
      <button onClick={onBack} style={backStyle}>← Back</button>
      <article style={articleStyle}>
        <h1 style={h1Style}>Terms of Service</h1>
        <p style={mutedStyle}>Last updated: April 2026</p>

        <Section title="Using mylodic">
          <p>mylodic is a platform for sharing musical moments. By using the service, you agree to post only content you have the right to share and to treat other users with respect.</p>
        </Section>

        <Section title="Content">
          <p>You retain ownership of your captions and voice notes. By posting, you grant mylodic a non-exclusive licence to display and distribute your content within the platform. We may remove content that violates these terms without notice.</p>
        </Section>

        <Section title="Music">
          <p>mylodic displays track metadata from Spotify and streams 30-second previews via Deezer. We do not reproduce full tracks or facilitate infringement. Your use of linked Spotify/Deezer content is subject to their respective terms.</p>
        </Section>

        <Section title="Account termination">
          <p>We reserve the right to suspend or terminate accounts that violate these terms. You may delete your account at any time from the Edit Profile page.</p>
        </Section>

        <Section title="Limitation of liability">
          <p>mylodic is provided "as is". We make no warranties and are not liable for any damages arising from your use of the service.</p>
        </Section>

        <Section title="Contact">
          <p>Questions? Email <a href="mailto:mylodic.contact@gmail.com" style={{ color: 'var(--accent)' }}>mylodic.contact@gmail.com</a>.</p>
        </Section>
      </article>
    </div>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section style={{ marginTop: 28 }}>
      <h2 style={{ fontSize: 15, fontWeight: 700, marginBottom: 8 }}>{title}</h2>
      <div style={{ fontSize: 14, color: 'var(--text-muted)', lineHeight: 1.7 }}>{children}</div>
    </section>
  );
}

const pageStyle: React.CSSProperties = {
  maxWidth: 620,
  margin: '0 auto',
  padding: '24px 20px 64px',
};

const backStyle: React.CSSProperties = {
  fontSize: 13,
  color: 'var(--text-muted)',
  marginBottom: 28,
  display: 'inline-block',
  cursor: 'pointer',
};

const articleStyle: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
};

const h1Style: React.CSSProperties = {
  fontSize: 24,
  fontWeight: 800,
  letterSpacing: '-0.02em',
  marginBottom: 4,
};

const mutedStyle: React.CSSProperties = {
  fontSize: 12,
  color: 'var(--text-muted)',
};
